import { BrowserRouter as Router } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from 'react-query'
import { Toaster } from 'react-hot-toast'
import { AuthProvider } from './contexts/AuthContext'
import { AbilityProvider } from './contexts/AbilityContext'
import { UserPreferenceProvider } from './contexts/UserPreferenceContext'
import { ReportIssueWidgetProvider } from './contexts/ReportIssueWidgetContext'
import { CompanyFilterProvider } from './contexts/CompanyFilterContext'
import { AppRouter } from './router'
import { ChaaiAssistantWidget } from './components/chaai-assistant/ChaaiAssistantWidget'
import { ReportIssueWidget } from './features/system-issues/components/ReportIssueWidget'
import { AlertsProvider } from './features/alerts/AlertsProvider'
import { ThemeProvider } from './contexts/ThemeContext'
import { ThemeSync } from './components/ThemeSync'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
  },
})

function App() {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <UserPreferenceProvider>
            <CompanyFilterProvider>
              <ThemeSync />
              <AbilityProvider>
                <Router>
                  <AlertsProvider>
                    <ReportIssueWidgetProvider>
                      <AppRouter />
                      <ChaaiAssistantWidget />
                      <ReportIssueWidget />
                      <Toaster position="top-right" />
                    </ReportIssueWidgetProvider>
                  </AlertsProvider>
                </Router>
              </AbilityProvider>
            </CompanyFilterProvider>
          </UserPreferenceProvider>
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  )
}

export default App
